import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';

import _ from 'lodash';

import { connect } from 'react-redux';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import EsmsDialog from '../../components/EsmsDialog';

import validator, { debounceTimeout } from '../../helpers/validator';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

import classes from './CreateEntityModal.module.css';

class CreateCampusSiteModal extends Component {
    state = {
        event:           null,
        formIsValid:     false,
        open:            null,
        filteredOptions: [],
        formControls:    {
            sites: {
                value:           [],
                ids:             [],
                placeholder:     'Select Sites',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {
                    isNonemptyArray: true
                }
            }
        }
    }

    resetModal = () => {
        const options = this.setOptions();
        const updatedControls = this.setForm();


        this.setState({
            filteredOptions: options,
            formControls:    updatedControls,
            formIsValid:     false
        });
    }

    setForm = () => {
        const updatedControls = {
            ...this.state.formControls
        };

        for (let formControl in updatedControls) {
            updatedControls[formControl].value = [];
            updatedControls[formControl].ids = [];
            updatedControls[formControl].touched = false;
            updatedControls[formControl].valid = false;
        }

        return updatedControls;
    }

    setOptions = () => {
        const { campusSites, sites } = this.props;

        const normalized = campusSites.map(({ id }) => id);

        return sites.filter(value => !normalized.includes(value.id));
    }

    validatorDebounce = _.debounce(() => {
        const validatedState = validator(this.state, this.state.event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });
    }, debounceTimeout);

    updateControls = (value, event, id) => {
        const name = event.target.name;
        const updatedControls = { ...this.state.formControls };

        updatedControls[name].value = value;
        updatedControls[name].ids = updatedControls[name].ids.includes(id)
            ? updatedControls[name].ids.filter(c => c !== id)
            : [...updatedControls[name].ids, id];

        this.setState({
            event:        { ...event },
            formControls: updatedControls
        });

        this.validatorDebounce();
    }

    handleChange = (event, index) => {
        const value = event.target.value;
        // Defect in Material UI, '.$' is being prepended to the key prop of the
        // react synthetic object coming in as "index"
        const id = index.key.replace('.$', '');

        this.props.toggleLoading(false);

        this.updateControls(value, event, id);
    }

    handleCreate = async () => {
        const { clearErrors, createCampusSite, selectedNode } = this.props;
        const sitesSelected = this.state.formControls.sites.ids;
        let isCreated;

        const parents = selectedNode.parent.split('/');
        const clientId = parents[parents.length - 1];

        clearErrors();

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            isCreated = await createCampusSite(selectedNode.id, sitesSelected, clientId);
        }

        if (isCreated) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    render() {
        const {
            errors,
            isLoading,
            open,
            selectedNode,
            title
        } = this.props;

        return (
            <EsmsDialog
                errors={errors}
                open={open}
                onClose={this.handleClose}
                title={title}
                onRendered={this.resetModal}
                onConfirm={this.handleCreate}
                disabled={!this.state.formIsValid}
                isLoading={isLoading}
                confirmText="Create"
            >
                <div className={classes.formColumn}>
                    <div className={classes.labelColumn}>
                        <div className={classes.labelHeader}>
                            <img src="/assets/images/siteTreeIcon.svg" alt="site icon" />
                            <span>Add Sites to Campus</span>
                        </div>
                        <div className={classes.labelContent}>
                            <p>
                                Select Sites to add to Campus: {selectedNode.name}.
                            </p>
                        </div>
                    </div>
                    <div className={classes.inputColumn}>
                        <div className={classes.inputs}>
                            <FormControl className={classes.fullWidth}>
                                <InputLabel
                                    htmlFor="sites"
                                    classes={{
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }}
                                >
                                    {this.state.formControls.sites.placeholder}
                                </InputLabel>
                                <Select
                                    multiple
                                    value={this.state.formControls.sites.value}
                                    id="sites"
                                    input={<Input id="select-multiple-checkbox" />}
                                    renderValue={selected => selected.join(', ')}
                                    onChange={this.handleChange}
                                    name="site"
                                    className={`${classes.cssUnderline} ${classes.input}`}
                                    inputProps={{
                                        name: 'sites',
                                        id:   'sites'
                                    }}
                                >
                                    {
                                        this.state.filteredOptions.map(site => (
                                            <MenuItem
                                                className={classes.selectMenuItem}
                                                value={site.name}
                                                key={site.id}
                                            >
                                                <Checkbox
                                                    color="primary"
                                                    checked={this.state.formControls.sites.value.indexOf(site.name) > -1}
                                                />

                                                <span>{site.name}</span>
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </div>
            </EsmsDialog >
        );
    }
}

CreateCampusSiteModal.propTypes = {
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        campusSites:  state.architect.campusSites,
        clientNodes:  state.architect.clientNodes,
        companyInfo:  state.companyInfo,
        errors:       state.messages.errors,
        isLoading:    state.ui.isLoading,
        selectedNode: state.architect.selectedNode,
        sites:        state.site.sites
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCampusSiteModal);
